import { Navigate, type RouteObject } from "react-router-dom";
import { useLocale } from "@admin/app/locale";
import { useSessionQuery } from "@/shared/services/useSessionQuery";
import { ADMIN_ROLES } from "@/lib/auth/admin-roles";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { LoadingState } from "@/shared/rd";
import { PaidServicesPage } from "./pages/PaidServicesPage";

/** Platform admin (super admin) only — the API refuses anyone else too. */
function PaidServicesRoute() {
  const locale = useLocale();
  const t = useTranslations();
  const session = useSessionQuery();
  if (session.isLoading)
    return <LoadingState title={t(keys.shell.loadingTitle, { page: t(keys.paidServices.nav).toLocaleLowerCase(locale) })} sub={t(keys.shell.loadingSub)} rows={0} />;
  if (!session.data?.admin?.roles?.includes(ADMIN_ROLES.SUPER_ADMIN))
    return <Navigate to={`/${locale}/admin`} replace />;
  return <PaidServicesPage locale={locale} />;
}

export const paidServicesRoutes: RouteObject[] = [
  { path: "paid-services", element: <PaidServicesRoute /> },
];
